module.exports = __webpack_public_path__ + "static/media/family_white.f46f49c8.png";